import React from 'react'
import { Error } from '../../'

class ErrorContainer extends React.Component {
  constructor() {
    super()

    this.state = {
      hasError: false,
    }
  }
  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
    })
    console.log(error, info)
  }

  render() {
    const {
      children,
      resetApp,
    } = this.props

    const { hasError } = this.state

    return (
      <React.Fragment>
        {hasError ? (
          <Error resetApp={resetApp} />
        ) : (
          <React.Fragment>
            {children}
          </React.Fragment>
        )}
      </React.Fragment>
    )
  }
}

export default ErrorContainer



// WEBPACK FOOTER //
// ./src/modules/core/components/errorContainer.jsx